import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { RandomQuestionResponse } from '../models/notes/random-question.model';

@Injectable({
	providedIn: 'root',
})
export class RandomQuestionService {
	constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

	private randomQuestionEndpoint: string = this.environmentService.getBaseUrl() + '/api/note/questions';

	public getRandomQuestions(): Observable<RandomQuestionResponse> {
		return this.http.get<RandomQuestionResponse>(this.randomQuestionEndpoint)
			.pipe(map(res => { return res; }));
	}
}
